import React from 'react'
import PropTypes from 'prop-types'

const BASE = 'tw:flex tw:items-center tw:gap-3 tw:p-3 tw:rounded-md! tw:text-sm'

const VARIANTS = {
  info: {
    box: 'tw:bg-ds-info-lowest tw:text-ds-neutral-highest',
    icon: 'fas fa-info-circle tw:text-ds-info'
  },
  warning: {
    box: 'tw:bg-ds-warning-lowest tw:text-ds-warning',
    icon: 'fas fa-exclamation-circle tw:text-ds-warning'
  },
  danger: {
    box: 'tw:bg-ds-danger-lowest tw:text-ds-danger',
    icon: 'fas fa-times-circle tw:text-ds-danger'
  },
  success: {
    box: 'tw:bg-ds-primary-lowest tw:text-ds-primary-highest',
    icon: 'fas fa-check-circle tw:text-ds-primary'
  },
  neutral: {
    box: 'tw:bg-white tw:border tw:border-solid tw:border-gray-300 tw:p-4 tw:gap-4 tw:text-gray-600',
    icon: 'fas fa-info-circle tw:text-gray-600'
  }
}

const Banner = ({ children, variant, className }) => {
  const styles = VARIANTS[variant]
  return (
    <div className={`${BASE} ${styles.box} ${className}`.trim()} role="status">
      <i className={`${styles.icon} tw:text-base`} />
      <div className="tw:min-w-0">{children}</div>
    </div>
  )
}

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['info', 'warning', 'danger', 'success', 'neutral'])
}

Banner.defaultProps = {
  className: '',
  variant: 'info'
}

export default Banner
